import DataTable from "datatables.net-react";
import { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from 'sweetalert2';
import { JvLedgerService } from "../../services/JvLedgerService.js";
import * as BullCache from "../../util/BullCache";
import { customStyles, the } from '../components/customStyles.js';
import From from '../components/From';
import To from '../components/To';


function Jvledger() {

  const [loading, setLoading] = useState(false);
  const [client, setClient] = useState([]);
  const [jvList, setJvList] = useState([]);
  const [selectedClient, setSelectedClient] = useState('');
  const [jvId, setJvId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [selectedLastdate, setSelectedLastdate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const handleClose = () => setShowModal(false);
  const [fromUser, setFromUser] = useState('');
  const [toUser, setToUser] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [amount, setAmount] = useState('');
  const [remark, setRemark] = useState('');
  const [paymentType, setPaymentType] = useState("");
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [calledFirstTime, setCalledFirstTime] = useState(false);



  var user = BullCache.getFromCache("user");
  const navigate = useNavigate();
  useEffect(() => {
    const currentDate = new Date();
    currentDate.setDate(1);
    const firstDayOfMonth = currentDate.toISOString().split("T")[0];

    setSelectedDate(firstDayOfMonth);


    if (!user.adminId) return
    JvLedgerService.getUsers({ adminId: user.adminId }).then((res) => {
      if (res.code === 1) {
        if (res.data.userList.length > 0) {
          setClient(res.data.userList);
        }
      }
    });
  }, [user.adminId]);

  const handleClientChange = (selectedOption) => {
    setSelectedClient(selectedOption ? selectedOption.value : '');
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleLastdateChange = (e) => {
    setSelectedLastdate(e.target.value);
  };
  const handleFromDateChange = (newDate) => {
    setFromDate(newDate);
    setSelectedDate(newDate);
  };
  const handleToDateChange = (newDate) => {
    setToDate(newDate);
    setSelectedLastdate(newDate);
  };
  const clientOptions = client.map(c => ({
    value: c.userid,
    label: `${c.firstName} (${c.userName})`
  }));


  useEffect(() => {
    if (fromDate && toDate && !calledFirstTime) {
      const dataToSubmit = {
        adminId: user.adminId,
        date: fromDate,
        endDate: toDate,
      };

      fetchData(dataToSubmit);
      setCalledFirstTime(true);
    }
  }, [fromDate, toDate]);


  const fetchData = (dataToSubmit) => {
    setLoading(true);
    JvLedgerService.getJvList(dataToSubmit)
      .then((resp) => {
        setLoading(false);
        if (resp.code === 1 && resp.data.jvList.length > 0) {
          setJvList(resp.data.jvList);
        } else {
          setJvList([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching trade data:', error);
      });
  };

  const jvSearch = () => {

    const payment = {
      userId: selectedClient,
      date: fromDate || selectedDate,
      endDate: toDate || selectedLastdate,
    };
    setLoading(true);
    JvLedgerService.getJvList(payment).then((resp) => {
    setLoading(false);
      if (resp.code === 1) {
        if (resp.data.jvList.length > 0) {
          setJvList(resp.data.jvList);
        } else {
          setJvList([]);

        }
      } else {
        setJvList([]);
      }
    });
  }

  const handleDelete = (rowData) => {
    const requestData = {
      adminId: user.adminId,
      jvId: rowData.jvId,
    };

    JvLedgerService.deleteJv(requestData).then((res) => {
      if (res.code === 1) {
        Swal.fire({
          icon: "success",
          text: "Deleted Successfully!",
        });
        jvSearch();
        handleClose();
      } else {
        Swal.fire({
          icon: "error",
          text: res.message || "Failed to Delete!",
        });
      }
    });
  };


  useEffect(() => {
    const handlePencilClick = (event) => {
      const jvId = event.target.getAttribute("data-id");
      const rowData = jvList.find((jv) => jv.jvId === jvId);
      if (rowData) {
        setFromUser(`${rowData.userFrom.firstName} (${rowData.userFrom.userName})`);
        setToUser(`${rowData.userTo.firstName} (${rowData.userTo.userName})`);
        setFrom(rowData.userFrom.userid);
        setJvId(rowData.jvId);
        setFrom(rowData.userFrom.userid);
        setTo(rowData.userTo.userid);
        setAmount(rowData.amount);
        setRemark(rowData.remark);
        setSelectedDate(rowData.createdDate);
        setPaymentType(rowData.paymentType);

      }
      setShowModal(true);
    };

    const handleTrashClick = (event) => {
      const jvId = event.target.getAttribute("data-id");
      const rowData = jvList.find((jv) => jv.jvId === jvId);
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No',
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          handleDelete(rowData);
        }
      });
    };

    document.addEventListener("click", (event) => {
      if (event.target.classList.contains("icon-pencil")) {
        handlePencilClick(event);
      } else if (event.target.classList.contains("icon-trash")) {
        handleTrashClick(event);
      }
    });

    return () => {
      document.removeEventListener("click", handlePencilClick);
      document.removeEventListener("click", handleTrashClick);
    };
  }, [jvList]);

  const handleUpdate = () => {
    const updatedJv = {
      jvId,
      paymentType,
      amount,
      remark,
      createdDate: selectedDate,
      from: from,
      to: to,
      jvType: "CLIENT",
    };

    JvLedgerService.getUpdateJv(updatedJv).then(response => {
      if (response.code === 1) {
        Swal.fire({
          icon: "success",
          text: "Updated !",
        });
        const updatedJvList = jvList.map((jv) =>
          jv.jvId === jvId
            ? { ...jv, paymentType, amount, remark, createdDate: selectedDate }
            : jv
        );
        setJvList(updatedJvList);
        handleClose();
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Failed Save Changes!",
        });
      }
    }).catch(error => {
      Swal.fire({
        icon: "error",
        title: error,
        text: "Something Went to Wrong!",
      });
    });
  };
  const columns = [
    {
      title: "FROM",
      className: "  text-center fss-1 font-bold ledger bg-body ",
      render: (data, type, full, meta) => {
        const userFrom = full.userFrom ? full.userFrom.firstName + " (" + full.userFrom.userName + ")" : "No User";
        return userFrom;
      }
    },
    {
      title: "TO",
      className: "  text-center fss-1 font-bold ledger bg-body ",
      render: (data, type, full, meta) => {
        const userTo = full.userTo ? full.userTo.firstName +" (" + full.userTo.userName + ")" : "No User";
        return userTo;
      }
    },
    {
      title: "DATE",
      data: "createdDate",
      className: " ledger bg-body text-center font-bold fss-1",
      render: (data) => {
        return new Date(data).toLocaleDateString();
      },
    }
    ,
    {
      title: "AMOUNT",
      data: "amount",
      className: " ledger bg-body text-center font-bold fss-1 ",
    },
    {
      title: "REMARK",
      data: "remark",
      className: " ledger bg-body text-center font-bold  fss-1 ",
    },
    {
      title: "ACTION",
      className: " ledger bg-body text-center font-bold  fss-1 ",
      render: (data, type, full, meta) => {
        return `
        <i class="me-3 fa fa-pencil icon-pencil" data-id="${full.jvId}" style="cursor: pointer"></i>
        <i class="icon-trash fa fa-trash" data-id="${full.jvId}" style="cursor: pointer; color: red"></i>
      `;
      },
    },
  ];

  return (

    <div>
      <Card className="mt-2 ">
        <Card.Body>

          <Row>
            <Col sm={2} xs={6} className="text-start" >
              <b className="h6 fss-05">SELECT </b>
              <Select
                options={clientOptions}
                value={clientOptions.find(option => option.value === selectedClient)}
                onChange={handleClientChange}
                placeholder="Select"
                isClearable={true}
                className=" text-black"
                isSearchable={true}
                styles={customStyles}
                theme={the}
              />            </Col>


            <Col sm={2} xs={6} xl={1} className=''>
              <b className='h6 fss-05'>FROM</b><br />
              <From fromDate={fromDate} onDateChange={handleFromDateChange} />
            </Col>
            <Col sm={2} xs={6} className=''>
              <b className='h6 fss-05'>TO</b><br />
              <To toDate={toDate} setToDate={handleToDateChange} />
            </Col>

            <Col sm={2} xs={6} className="mt-4">
              <Button variant="success" size="sm w-75" onClick={jvSearch} >
                <b className="fss-11">SUBMIT</b>
              </Button>
            </Col>

            <Col></Col>
            <Col></Col>
            <Col></Col>
            <Col></Col>

          </Row>


        </Card.Body>
      </Card>

      <Card className="mt-2">
        <Card.Body>
          <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <DataTable
                id="table"
                className=" table bg-head-secondary table-bordered fss-05 white-bordered-table fss-09"
                columns={columns}
                data={jvList}
              />
            )}
          </div>
        </Card.Body>
      </Card>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>EDIT JV ENTRY</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className="col-6">FROM: {fromUser}</Col>

            <Col className="col-6 text-end">TO: {toUser}</Col>
          </Row>
          <hr />
          <Row className="mt-3 border rounded p-1">
            <Col className="col-5"><label>PAYMENT TYPE :</label></Col>

            <Col>
              <Form.Check
                type="radio"
                aria-label="radio 1"
                label="CASH"
                name="group2"
                checked={paymentType === "CASH"}
                onChange={() => setPaymentType("CASH")}
              />
            </Col>
            <Col>
              <Form.Check
                type="radio"
                aria-label="radio 2"
                label="ONLINE"
                name="group2"
                checked={paymentType === "ONLINE"}
                onChange={() => setPaymentType("ONLINE")}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col sm={12}>DATE</Col>
            <Col className="mt-1">
              <input
                type="date"
                size="lg"
                className="form-control"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col sm={12}>AMOUNT</Col>
            <Col className="mt-1">
              <input
                type="number"
                className="form-control  bg-light text-black"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="mt-3">
              REMARK
            </Col>
            <Col className="mt-1">
              <Form.Control
                as="textarea"
                className="custom-placeholder bg-light text-black"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
          <Button variant="success" onClick={handleUpdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

    </div>



  );


}

export default Jvledger;